import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from '@/components/icons';
import { toast } from 'sonner';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash;
    const params = new URLSearchParams(hash.substring(1));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/login');
      return;
    }

    const exchangeSession = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId })
        });

        if (!response.ok) {
          let detail = 'Accesso non autorizzato';
          try {
            const errorData = await response.json();
            detail = errorData?.detail || detail;
          } catch {}
          throw new Error(detail);
        }

        const data = await response.json();
        setUser(data.user);
        navigate('/dashboard', { replace: true, state: { user: data.user } });
      } catch (error) {
        console.error('Auth error:', error);
        toast.error(error.message || 'Accesso non autorizzato');
        navigate('/login', { replace: true });
      }
    };

    exchangeSession();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F7F5]">
      <div className="text-center space-y-4">
        <Loader2 className="w-12 h-12 animate-spin text-[#2C4C3B] mx-auto" />
        <p className="text-[#5C5C5C]">Autenticazione in corso...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
